import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';
import {
    Center,
    Loader
} from '@mantine/core';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useAllowedActions} from '../../hooks/useAllowedActions.ts';


export const MeteringRecordsLayout = () => {

    const {allowedActions, authorizing} = useAllowedActions();

    // FNP-1731: allowedActions is empty until the check settles; deciding before
    // then sends a signed-in deep link away from the page it asked for.
    if (authorizing) {
        return <Center><Loader/></Center>;
    }

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListMeteringRecords') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetMeteringRecord') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/metering-records'/>
                    )
                }
            />
        </Routes>
    );
};
